import React from 'react';

import Container from './Container';
import Text from './Text';
import Icon from './Icon';
import Date from './Date';

export default ({ event }) => (
  <Container title={`${event.status} (${event.code})`}>
    <Icon name="tag" />
    <Text>{event.description}</Text>
    <Date>{event.created_at}</Date>
  </Container>
);
